<template>
    <div class="form">
        <h4 class="step-title">
            What is the primary purpose of your vehicle?
        </h4>
        <div class="step-content d-flex flex-column align-items-center step-button-list wider">
            <button-list v-bind:items="primaryUseTypes" v-bind:onclick="primaryUseComplete" v-bind:value="vehicle.primaryUseType"/>
            <div class="step-item" v-if="primaryUseTypeRequired && vehicle.primaryUseType === null">
                <div class="alert alert-danger">Primary purpose required</div>
            </div>
        </div>
        <h4 class="step-title">
            How many miles do you drive in a year?
        </h4>
        <div class="step-content d-flex flex-column align-items-center step-button-list wider">
            <button-list v-bind:items="annualMileageRanges" v-bind:onclick="annualMileageComplete" v-bind:value="vehicle.annualMileage"/>
            <div class="step-item" v-if="annualMileageRequired && vehicle.annualMileage === null">
                <div class="alert alert-danger">Miles required</div>
            </div>
        </div>
        <h4 class="step-title">
            How many days do you commute?
        </h4>
        <div class="step-content d-flex flex-column align-items-center step-button-list wider">
            <button-list v-bind:items="daysDrivenPerWeekRanges" v-bind:onclick="daysDrivenPerWeekComplete" v-bind:value="vehicle.daysDrivenPerWeek"/>
            <div class="step-item" v-if="daysDrivenPerWeekRequired && vehicle.daysDrivenPerWeek === null">
                <div class="alert alert-danger">Days required</div>
            </div>
        </div>
        <h4 class="step-title">
            What type of coverage are you looking for?
        </h4>
        <div class="step-content d-flex flex-column align-items-center step-button-list wider">
            <button-list v-bind:items="coverageTypes" v-bind:onclick="coverageTypeComplete" v-bind:value="requestedCoverageTypeValue"/>
            <div class="step-item" v-if="primaryUseTypeRequired && vehicle.primaryUseType === null || annualMileageRequired && vehicle.annualMileage === null || daysDrivenPerWeekRequired && vehicle.daysDrivenPerWeek === null">
                <div class="alert alert-danger">Required question(s) not answered</div>
            </div>
        </div>
    </div>
</template>

<script>
    import ButtonList from "../shared/ButtonList.vue"

    export default {
        name: "VehiclePrimaryUseTypeAnnualMileageDaysDrivenPerWeekRequestedAutoCoverageType",
        components: {
            ButtonList
        },
        created: function() {
            if (this.vehicle.primaryUseType !== null || this.vehicle.annualMileage !== null || this.vehicle.daysDrivenPerWeek !== null) {
                this.requestedCoverageTypeValue = this.lead.autoInsurance.requestedCoverageType;
            }
        },
        data: function() {
            return {
                primaryUseTypes: [
                    { text: "Commuting", value: "CommuteWork" },
                    { text: "Business/Commercial", value: "Business" },
                    { text: "Personal/Pleasure", value: "Pleasure" }
                ],
                annualMileageRanges: [
                    { text: "Less than 12,000 miles", value: 12000 },
                    { text: "12,001-15,000 miles", value: 15000 },
                    { text: "15,001-20,000 miles", value: 20000 },
                    { text: "Over 20,000 miles", value: 25000 }
                ],
                daysDrivenPerWeekRanges: [
                    { text: "0-2 Days", value: 2 },
                    { text: "3-5 Days", value: 5 },
                    { text: "6-7 Days", value: 7 }
                ],
                coverageTypes: [
                    { text: "Preferred", value: "Premium" },
                    { text: "Standard", value: "Standard" },
                    { text: "State Minimum", value: "Minimum" }
                ],
                primaryUseTypeRequired: false,
                annualMileageRequired: false,
                daysDrivenPerWeekRequired: false,
                requestedCoverageTypeValue: null
            }
        },
        props: {
            lead: Object
        },
        computed: {
            vehicle: function() {
                return this.lead.autoInsurance.vehicles[this.lead.autoInsurance.vehicles.length-1];
            }
        },
        methods: {
            primaryUseComplete: function(value) {
                this.vehicle.primaryUseType = value;

                if (this.primaryUseTypeRequired && this.vehicle.annualMileage !== null && this.vehicle.daysDrivenPerWeek !== null && this.lead.autoInsurance.requestedCoverageType !== null) {
                    this.complete(this.lead.autoInsurance.requestedCoverageType);
                }
            },
            annualMileageComplete: function(value) {
                this.vehicle.annualMileage = value;

                if (this.annualMileageRequired && this.vehicle.primaryUseType !== null && this.vehicle.daysDrivenPerWeek !== null && this.lead.autoInsurance.requestedCoverageType !== null) {
                    this.complete(this.lead.autoInsurance.requestedCoverageType);
                }
            },
            daysDrivenPerWeekComplete: function(value) {
                this.vehicle.daysDrivenPerWeek = value;

                if (this.daysDrivenPerWeekRequired && this.vehicle.primaryUseType !== null && this.vehicle.annualMileage !== null && this.lead.autoInsurance.requestedCoverageType !== null) {
                    this.complete(this.lead.autoInsurance.requestedCoverageType);
                }
            },
            coverageTypeComplete: function(value) {
                var vehicle = this.vehicle;

                if (vehicle.primaryUseType === null) {
                    this.primaryUseTypeRequired = true;
                }

                if (vehicle.annualMileage === null) {
                    this.annualMileageRequired = true;
                }

                if (vehicle.daysDrivenPerWeek === null) {
                    this.daysDrivenPerWeekRequired = true;
                }

                this.lead.autoInsurance.requestedCoverageType = value;

                if (vehicle.primaryUseType !== null && vehicle.annualMileage !== null && vehicle.daysDrivenPerWeek !== null) {
                    this.complete(value);
                }
            },
            complete: function(value) {
                this.$emit("complete", this.$options.name, value);
            }
        }
    }
</script>
